import React from 'react';
import { ReactComponent as Shared } from '../../assets/images/icons/shared.svg';

export default function SharedIcon(props) {
  return (
    <Shared className={`icon ${props.className}`} />
  );
}
